import {installI18n} from '@malt/i18n';
import {nl2br} from '@malt/common';
import {escapeJs, escapeHtml} from '@malt/sanitize';

// trick to make jsdom tests work
/* istanbul ignore else  */
// if (typeof global !== 'undefined' && global !== window) {
//     // a direct call to require() would be resolved by Webpack, although in a "if"
//     IntlMessageFormat = eval("");
//     global.IntlMessageFormat = window.IntlMessageFormat = IntlMessageFormat;
// } else {
//     IntlMessageFormat = window.IntlMessageFormat;
// }

function unescapeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}

// adaptation of underscore.js's _.template (http://underscorejs.org/)
const template = (function () {
    const escapes = {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        '\u2028': 'u2028',
        '\u2029': 'u2029',
    };

    const escaper = /\\|'|\r|\n|\u2028|\u2029/g;

    const escapeChar = function (match) {
        return '\\' + escapes[match];
    };

    return function (text, settings) {
        settings = settings || {};
        const matcher = new RegExp([/\{\{-(.+?)\}\}/.source, /\{\{=(.+?)\}\}/.source, /\{\{(.+?)\}\}/.source].join('|') + '|$', 'g');

        let index = 0;
        let source = "__p+='";
        text.replace(matcher, (match, escape, interpolate, evaluate, offset) => {
            source += text.slice(index, offset).replace(escaper, escapeChar);
            index = offset + match.length;

            if (escape) {
                source += "'+\n((__t=(" + escape + "))==null?'':Hop.escapeHtml(__t))+\n'";
            } else if (interpolate) {
                source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
            } else if (evaluate) {
                source += "';\n" + evaluate + "\n__p+='";
            }
            return match;
        });
        source += "';\n";

        if (!settings.variable) {
            source = 'with(obj||{}){\n' + source + '}\n';
        }

        source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';

        let render;

        try {
            render = new Function(settings.variable || 'obj', 'Hop', source);
        } catch (e) {
            e.source = source;
            throw e;
        }

        const Template = function (data) {
            return render.call(this, data, Hop);
        };

        const argument = settings.variable || 'obj';
        Template.source = 'function(' + argument + '){\n' + source + '}';

        return Template;
    };
})();

function mixin(Hop) {
    Hop.unescapeHtml = unescapeHtml;
    Hop.escapeJs = escapeJs;
    Hop.escapeHtml = escapeHtml;
    Hop.template = template;
    Hop.nl2br = nl2br;

    const {msg, icuMsg, messageTemplate, requireMessage} = installI18n(window.HopMessages);
    // we could loop over object entries and apply each i18n tool dynamically, but it's easier to understand like so
    Hop.message = msg;
    Hop.icuMessage = icuMsg;
    Hop.messageTemplate = messageTemplate;
    Hop.requireMessage = requireMessage;
}

export {escapeJs, mixin, nl2br, template, unescapeHtml};
